import http from '@/http/fetch'

export const queryUserList = (params) => http.get('/governApi/user/queryUserList', params)
//脱敏 查询部分字段
export const queryUserListConceal = (params) => http.get('/governApi/user/queryUserListConceal', params)
//组管理使用 脱敏 查询部分字段
export const queryUserListConcealGroup = (params) => http.get('/governApi/user/queryUserListConcealGroup', params)

//查询部门列表
export const getDepartmentList = (params) => http.post('/governApi/user/getDepartmentList',params)
//查询机构列表
export const getInstitutionList = () => http.post('/governApi/user/getInstitutionList')
//组管理使用 查询机构列表
export const getInstitutionListGroup = () => http.post('/governApi/user/getInstitutionListGroup')

export const queryUserSelect = (params) => http.get('/governApi/user/queryUserSelect', params)

export const loginApi = (params) => http.post('/governApi/user/login', params, false)

export const userRegister = (params) => http.post('/governApi/user/userRegister', params, false)

export const checkLogin = (params) => http.post('/governApi/user/checkLogin', params, false)

export const removeToken = (token) => http.get(`/governApi/user/removeToken?token=${token}`, {}, false)

export const updateUserVerifyState = (params) => http.get('/governApi/user/updateUserVerifyState', params)

export const updateUserVerify = (params) => http.post('/governApi/user/updateUserVerify', params)

export const userRegisterNew = (params) => http.post('/governApi/user/userRegisterNew', params)

export const GetUserByExcel = (params) => http.post('/governApi/user/getUserByExcel', params)

export const addBatch = (params) => http.post('/governApi/user/addBatchUser', params)

export const downLoadModel = (params) => http.get('/governApi/files/downloadFile/' + params)

export const getEmailCode = (params) => http.get('/governApi/user/getEmailCode', params)

//生成姓名拼音setEnName
export const setEnName = () => http.post('/governApi/user/setEnName')
//转拼音
export const changeSpell = (params) => http.get('/governApi/user/changeSpell',params)
//忘记密码 验证账号邮箱 邮箱验证码 修改密码
export const forgetPassword = (params) => http.post('/governApi/user/forgetPassword',params)


//查看新用户
export const getSelectNullInstitutionUser = (params) => http.post('/governApi/user/selectNullInstitutionUser',params)

//设置机构
export const addSetInstitutionIdForUser = (params) => http.post('/governApi/user/setInstitutionIdForUser',params)

// 退出机构
export const selfExitInstitution = (params) => http.post('/governApi/user/selfExitInstitution',params)

// 查询机构

export const selectInstitution = (params) => http.post('/governApi/institution/selectInstitution',params)



export const queryUserHKY = (params) => http.post('/governApi/user/queryUserHKY',params)